import { useEffect, useState } from "react";
import { EventsType, useIdleTimer } from "react-idle-timer";
import { getEnvConfig } from "data/store/EnvConfig";

let getIsIdle: (() => boolean) | null = null;

export const isUserIdle = (): boolean => {
  return getIsIdle ? getIsIdle() : false;
};

export const IdleDetector: React.FC = () => {
  const [timeout, setTimeout] = useState(10 * 60 * 1000);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const config = await getEnvConfig();
        const timeoutMinutes = Number(config.inactivityThreshold) || 10;
        const timeoutMs = timeoutMinutes * 60 * 1000;

        setTimeout(timeoutMs);
      } catch (error) {
        console.error(
          "[IdleDetector] Error loading config, using default:",
          error,
        );
      }
    };

    loadConfig();
  }, []);

  const events: EventsType[] = ["mousedown", "keydown", "scroll", "touchstart"];

  const { isIdle } = useIdleTimer({
    timeout,
    debounce: 500,
    events,
  });

  useEffect(() => {
    getIsIdle = isIdle;
    return () => {
      getIsIdle = null;
    };
  }, [isIdle]);

  return null;
};
